export default "__VITE_ASSET__013de008__"